import React from "react";

const Video = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...rest}
  >
    <path
      fill="currentColor"
      d="M2.37,17.5a.65.65,0,0,0,.2.49.66.66,0,0,0,.49.2H16.12a.69.69,0,0,0,.5-.2.64.64,0,0,0,.19-.49V6.5A.66.66,0,0,0,16.62,6a.69.69,0,0,0-.5-.2H3.06a.68.68,0,0,0-.69.69ZM17.5,14.06l.69.69,2.75,2.75h.68V6.5h-.68L17.5,9.94Z"
    />
    <path
      fill="#fff"
      d="M1,17.5V6.5A2,2,0,0,1,1.6,5a2,2,0,0,1,1.46-.6H16.12a2,2,0,0,1,1.47.6,2,2,0,0,1,.6,1.46v.86L20,5.51a1.43,1.43,0,0,1,1-.38h.6a1.31,1.31,0,0,1,1,.4,1.36,1.36,0,0,1,.41,1v11a1.32,1.32,0,0,1-.41,1,1.34,1.34,0,0,1-1,.39H21a1.44,1.44,0,0,1-1-.39l-1.84-1.85v.86a2,2,0,0,1-.6,1.46,2,2,0,0,1-1.47.6H3.06A2,2,0,0,1,1.6,19,2,2,0,0,1,1,17.5Zm1.37,0a.65.65,0,0,0,.2.49.66.66,0,0,0,.49.2H16.12a.69.69,0,0,0,.5-.2.64.64,0,0,0,.19-.49V6.5A.66.66,0,0,0,16.62,6a.69.69,0,0,0-.5-.2H3.06a.68.68,0,0,0-.69.69ZM17.5,14.06l.69.69,2.75,2.75h.68V6.5h-.68L17.5,9.94Z"
    />
  </svg>
);

export default Video;
